import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, Building2, MapPin } from 'lucide-react';
import { Button } from '../components/ui/button';

const ProjectsPage = () => {
  const projects = [
    {
      id: 1,
      title: 'Pipeline Construction Project',
      client: 'NPDC',
      location: 'Delta State, Nigeria',
      duration: '6 months',
      category: 'Pipeline',
      description: 'Design and construction of 12km crude oil pipeline with associated facilities.',
      image: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800&auto=format&fit=crop&q=60',
    },
    {
      id: 2,
      title: 'Pump Installation & Commissioning',
      client: 'SPDC',
      location: 'Rivers State, Nigeria',
      duration: '3 months',
      category: 'Mechanical',
      description: 'Installation and commissioning of high-capacity transfer pumps for flow station upgrade.',
      image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&auto=format&fit=crop&q=60',
    },
    {
      id: 3,
      title: 'Compressor Installation',
      client: 'CON OIL',
      location: 'Edo State, Nigeria',
      duration: '4 months',
      category: 'Procurement',
      description: 'Supply, installation and commissioning of gas compression units.',
      image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&auto=format&fit=crop&q=60',
    },
    {
      id: 4,
      title: 'Tank Farm Construction',
      client: 'NPDC',
      location: 'Delta State, Nigeria',
      duration: '8 months',
      category: 'Civil',
      description: 'Construction of storage tank farm with 50,000 barrel capacity including all civil works.',
      image: 'https://images.unsplash.com/photo-1770099172083-724c91d9ccf6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxvaWwlMjBhbmQlMjBnYXMlMjBvZmZzaG9yZSUyMHBsYXRmb3JtJTIwb2NlYW58ZW58MHx8fHwxNzczODU0ODMwfDA&ixlib=rb-4.1.0&q=85',
    },
    {
      id: 5,
      title: 'Wellhead Maintenance Program',
      client: 'SPDC',
      location: 'Rivers State, Nigeria',
      duration: '12 months',
      category: 'Oil & Gas',
      description: 'Comprehensive wellhead maintenance and repair services for multiple production wells.',
      image: 'https://images.unsplash.com/photo-1758797849151-1725021be42a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxvaWwlMjBhbmQlMjBnYXMlMjBvZmZzaG9yZSUyMHBsYXRmb3JtJTIwb2NlYW58ZW58MHx8fHwxNzczODU0ODMwfDA&ixlib=rb-4.1.0&q=85',
    },
    {
      id: 6,
      title: 'Marine Logistics Support',
      client: 'Multiple Clients',
      location: 'Niger Delta Region',
      duration: 'Ongoing',
      category: 'Marine',
      description: 'Provision of tug boats and barges for offshore support operations.',
      image: 'https://images.unsplash.com/photo-1765048639586-8f3c3ed36a04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxvaWwlMjBhbmQlMjBnYXMlMjBvZmZzaG9yZSUyMHBsYXRmb3JtJTIwb2NlYW58ZW58MHx8fHwxNzczODU0ODMwfDA&ixlib=rb-4.1.0&q=85',
    },
    {
      id: 7,
      title: 'Flow Station Upgrade',
      client: 'NPDC',
      location: 'Delta State, Nigeria',
      duration: '5 months',
      category: 'Mechanical',
      description: 'Complete mechanical upgrade of existing flow station including piping and instrumentation.',
      image: 'https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwZW5naW5lZXJpbmclMjBjb25zdHJ1Y3Rpb24lMjB3b3JrZXIlMjBzYWZldHklMjBoZWxtZXR8ZW58MHx8fHwxNzczODU0ODMxfDA&ixlib=rb-4.1.0&q=85',
    },
    {
      id: 8,
      title: 'Bridge Construction Project',
      client: 'Government Agency',
      location: 'Delta State, Nigeria',
      duration: '10 months',
      category: 'Civil',
      description: 'Design and construction of reinforced concrete bridge for community access.',
      image: 'https://images.unsplash.com/photo-1513828583688-c52646db42da?w=800&auto=format&fit=crop&q=60',
    },
  ];

  const categories = ['All', 'Pipeline', 'Mechanical', 'Procurement', 'Civil', 'Oil & Gas', 'Marine'];

  return (
    <div data-testid="projects-page">
      {/* Hero Section */}
      <section className="pt-32 pb-20 md:pt-40 md:pb-32 bg-[#F5F5F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="inline-block px-4 py-2 bg-[#FF6B00] text-white text-xs uppercase tracking-widest font-bold mb-6">
              Our Portfolio
            </span>
            <h1 className="font-['Barlow_Condensed'] text-4xl md:text-6xl font-bold text-[#0A0A0A] uppercase leading-tight tracking-tight mb-6">
              Projects & Achievements
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Explore our portfolio of successfully completed projects for leading oil & gas companies across Nigeria and beyond.
            </p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-12 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl md:text-5xl font-bold text-[#FF6B00] font-['Barlow_Condensed']">50+</div>
              <div className="text-sm text-slate-400 uppercase tracking-wider mt-2">Projects Completed</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-[#FF6B00] font-['Barlow_Condensed']">15+</div>
              <div className="text-sm text-slate-400 uppercase tracking-wider mt-2">Major Clients</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-[#FF6B00] font-['Barlow_Condensed']">100%</div>
              <div className="text-sm text-slate-400 uppercase tracking-wider mt-2">On-Time Delivery</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-[#FF6B00] font-['Barlow_Condensed']">0</div>
              <div className="text-sm text-slate-400 uppercase tracking-wider mt-2">Safety Incidents</div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-20 md:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project) => (
              <div 
                key={project.id}
                className="group cursor-pointer bg-white shadow-sm hover:shadow-xl transition-all duration-300"
                data-testid={`project-card-${project.id}`}
              >
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 bg-[#FF6B00] text-white text-xs uppercase tracking-wider font-bold">
                      {project.category}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="font-['Barlow_Condensed'] text-xl font-bold text-[#0A0A0A] uppercase mb-3 group-hover:text-[#FF6B00] transition-colors">
                    {project.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed mb-4">
                    {project.description}
                  </p>
                  <div className="space-y-2 text-sm text-slate-500">
                    <div className="flex items-center gap-2">
                      <Building2 size={14} className="text-[#FF6B00]" />
                      <span>Client: {project.client}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <MapPin size={14} className="text-[#FF6B00]" />
                      <span>{project.location}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Calendar size={14} className="text-[#FF6B00]" />
                      <span>Duration: {project.duration}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Clients Section */}
      <section className="py-20 md:py-32 bg-[#F5F5F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-[#FF6B00] text-sm uppercase tracking-widest font-bold">
              Trusted By
            </span>
            <h2 className="font-['Barlow_Condensed'] text-3xl md:text-5xl font-bold text-[#0A0A0A] uppercase tracking-tight mt-4">
              Our Valued Clients
            </h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 items-center">
            {['NPDC', 'SPDC', 'CON OIL', 'NNPC', 'Seplat', 'Chevron'].map((client, index) => (
              <div 
                key={index}
                className="bg-white p-6 flex items-center justify-center h-24 hover:shadow-md transition-shadow"
              >
                <span className="font-['Barlow_Condensed'] text-xl font-bold text-slate-400 hover:text-[#FF6B00] transition-colors">
                  {client}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 md:py-32 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-['Barlow_Condensed'] text-3xl md:text-5xl font-bold text-white uppercase tracking-tight mb-6">
            Ready to Start Your Project?
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto mb-10">
            Let us bring our expertise and track record to your next engineering project.
          </p>
          <Link to="/contact">
            <Button 
              data-testid="projects-page-cta"
              className="bg-[#FF6B00] text-white hover:bg-[#E65000] rounded-none uppercase tracking-wider font-bold px-10 py-6 text-base btn-glow"
            >
              Discuss Your Project
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ProjectsPage;
